// extracted by mini-css-extract-plugin
module.exports = {"CoursesListItems":"CoursesListItems_CoursesListItems__1NKan","CoursesListItem":"CoursesListItems_CoursesListItem__2lc77"};